module.exports = __webpack_public_path__ + "static/media/video-icon3.5b01cefe.svg";